<script lang='ts'>
  export let title: string;
  export let src: string;
  export let alt: string;
</script>

<div class="md:flex my-7">
  <div style="min-width: 76px;" class="float-left mr-6 md:mr-0 md:float-none">
    <img class="w-full" {src} aria-hidden="true" {alt} />
  </div>
  <div class="text md:pl-16 flex-grow">
    <h3 class="text-blue text-3xl font-semibold mb-4">{title}</h3>
    <p class="text-gray text-xl"><slot></slot></p>
  </div>
</div>